import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { usePatientContext } from '../../../contexts/patient-context';
import { isAnyRequiredFieldMissing } from '../utils';

const PatientGuardComponentContents = () => {
  const { patient, getPatient } = usePatientContext();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (
      patient &&
      isAnyRequiredFieldMissing(patient) &&
      !location.pathname.includes('patient-details/edit')
    ) {
      navigate('./patient-details/edit', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPatient, patient, location.pathname]);

  return patient ? <Outlet /> : null;
};

export default PatientGuardComponentContents;
